import type { EpocusEncounter } from "$global-providers/rxdb-provider/collections/epocus-encounter";

type DicomNameParts = {
  family: string;
  given: string;
  middle: string;
};

export const splitDicomPatientName = (
  raw: EpocusEncounter["patientName"],
): DicomNameParts | null => {
  const name = raw?.trim() ?? "";
  if (!name.includes("^")) return null;
  const [family = "", given = "", middle = ""] = name
    .split("^")
    .map((part) => part.trim());
  return { family, given, middle };
};

export const formatDicomPatientName = (
  raw: EpocusEncounter["patientName"],
): string => {
  const name = raw?.trim() ?? "";
  const parts = splitDicomPatientName(name);
  if (!parts) return name;
  return [parts.given, parts.middle, parts.family].filter(Boolean).join(" ");
};
